module.exports = __webpack_public_path__ + "assets/nerves.f4898190.svg";